var _mask, _path, _path2, _path3, _mask2, _path4, _path5, _path6, _mask3, _path7, _path8, _path9, _mask4, _path10, _path11, _path12, _mask5, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_41_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895433 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V8.66667C22 9.77123 21.1046 10.6667 20 10.6667H2C0.89543 10.6667 0 9.77124 0 8.66667V2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895433 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V8.66667C22 9.77123 21.1046 10.6667 20 10.6667H2C0.89543 10.6667 0 9.77124 0 8.66667V2Z",
    fill: "#F59600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C-1 -1.65685 0.343146 -3 2 -3H20C21.6569 -3 23 -1.65685 23 0L21 3C21 3 20.5523 3 20 3H2C1.44772 3 1 3 1 3L-1 0ZM23 10.6667C23 12.3235 21.6569 13.6667 20 13.6667H2C0.343146 13.6667 -1 12.3235 -1 10.6667L1 7.66667C1 7.66667 1.44772 7.66667 2 7.66667H20C20.5523 7.66667 21 7.66667 21 7.66667L23 10.6667ZM2 13.6667C0.343146 13.6667 -1 12.3235 -1 10.6667V0C-1 -1.65685 0.343146 -3 2 -3V3C1.44772 3 1 3 1 3V7.66667C1 7.66667 1.44772 7.66667 2 7.66667V13.6667ZM20 -3C21.6569 -3 23 -1.65685 23 0V10.6667C23 12.3235 21.6569 13.6667 20 13.6667V7.66667C20.5523 7.66667 21 7.66667 21 7.66667V3C21 3 20.5523 3 20 3V-3Z",
    fill: "black",
    mask: "url(#path-1-inside-1_41_9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C-1 -1.65685 0.343146 -3 2 -3H20C21.6569 -3 23 -1.65685 23 0L21 3C21 3 20.5523 3 20 3H2C1.44772 3 1 3 1 3L-1 0ZM23 10.6667C23 12.3235 21.6569 13.6667 20 13.6667H2C0.343146 13.6667 -1 12.3235 -1 10.6667L1 7.66667C1 7.66667 1.44772 7.66667 2 7.66667H20C20.5523 7.66667 21 7.66667 21 7.66667L23 10.6667ZM2 13.6667C0.343146 13.6667 -1 12.3235 -1 10.6667V0C-1 -1.65685 0.343146 -3 2 -3V3C1.44772 3 1 3 1 3V7.66667C1 7.66667 1.44772 7.66667 2 7.66667V13.6667ZM20 -3C21.6569 -3 23 -1.65685 23 0V10.6667C23 12.3235 21.6569 13.6667 20 13.6667V7.66667C20.5523 7.66667 21 7.66667 21 7.66667V3C21 3 20.5523 3 20 3V-3Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_41_9)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_41_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6667H22V21.3333H0V10.6667Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6667H22V21.3333H0V10.6667Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6667V10.1667L-1 10.6667H0ZM22 10.6667H23L22 10.1667V10.6667ZM22 21.3333V21.8333L23 21.3333H22ZM0 21.3333H-1L0 21.8333V21.3333ZM0 10.6667V11.1667H22V10.6667V10.1667H0V10.6667ZM22 10.6667H21V21.3333H22H23V10.6667H22ZM22 21.3333V20.8333H0V21.3333V21.8333H22V21.3333ZM0 21.3333H1V10.6667H0H-1V21.3333H0Z",
    fill: "black",
    mask: "url(#path-3-inside-2_41_9)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6667V10.1667L-1 10.6667H0ZM22 10.6667H23L22 10.1667V10.6667ZM22 21.3333V21.8333L23 21.3333H22ZM0 21.3333H-1L0 21.8333V21.3333ZM0 10.6667V11.1667H22V10.6667V10.1667H0V10.6667ZM22 10.6667H21V21.3333H22H23V10.6667H22ZM22 21.3333V20.8333H0V21.3333V21.8333H22V21.3333ZM0 21.3333H1V10.6667H0H-1V21.3333H0Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-3-inside-2_41_9)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_41_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333H22V32H0V21.3333Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333H22V32H0V21.3333Z",
    fill: "#F59600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333V20.8333L-1 21.3333H0ZM22 21.3333H23L22 20.8333V21.3333ZM22 32V33L23 32H22ZM0 32H-1L0 33V32ZM0 21.3333V21.8333H22V21.3333V20.8333H0V21.3333ZM22 21.3333H21V32H22H23V21.3333H22ZM22 32V31H0V32V33H22V32ZM0 32H1V21.3333H0H-1V32H0Z",
    fill: "black",
    mask: "url(#path-5-inside-3_41_9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333V20.8333L-1 21.3333H0ZM22 21.3333H23L22 20.8333V21.3333ZM22 32V33L23 32H22ZM0 32H-1L0 33V32ZM0 21.3333V21.8333H22V21.3333V20.8333H0V21.3333ZM22 21.3333H21V32H22H23V21.3333H22ZM22 32V31H0V32V33H22V32ZM0 32H1V21.3333H0H-1V32H0Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-5-inside-3_41_9)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_41_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895433 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V8.66667C22 9.77123 21.1046 10.6667 20 10.6667H2C0.89543 10.6667 0 9.77124 0 8.66667V2Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895433 0.895431 0 2 0H20C21.1046 0 22 0.895431 22 2V8.66667C22 9.77123 21.1046 10.6667 20 10.6667H2C0.89543 10.6667 0 9.77124 0 8.66667V2Z",
    fill: "#F59600"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C-1 -1.65685 0.343146 -3 2 -3H20C21.6569 -3 23 -1.65685 23 0L21 3C21 3 20.5523 3 20 3H2C1.44772 3 1 3 1 3L-1 0ZM23 10.6667C23 12.3235 21.6569 13.6667 20 13.6667H2C0.343146 13.6667 -1 12.3235 -1 10.6667L1 7.66667C1 7.66667 1.44772 7.66667 2 7.66667H20C20.5523 7.66667 21 7.66667 21 7.66667L23 10.6667ZM2 13.6667C0.343146 13.6667 -1 12.3235 -1 10.6667V0C-1 -1.65685 0.343146 -3 2 -3V3C1.44772 3 1 3 1 3V7.66667C1 7.66667 1.44772 7.66667 2 7.66667V13.6667ZM20 -3C21.6569 -3 23 -1.65685 23 0V10.6667C23 12.3235 21.6569 13.6667 20 13.6667V7.66667C20.5523 7.66667 21 7.66667 21 7.66667V3C21 3 20.5523 3 20 3V-3Z",
    fill: "black",
    mask: "url(#path-7-inside-4_41_9)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C-1 -1.65685 0.343146 -3 2 -3H20C21.6569 -3 23 -1.65685 23 0L21 3C21 3 20.5523 3 20 3H2C1.44772 3 1 3 1 3L-1 0ZM23 10.6667C23 12.3235 21.6569 13.6667 20 13.6667H2C0.343146 13.6667 -1 12.3235 -1 10.6667L1 7.66667C1 7.66667 1.44772 7.66667 2 7.66667H20C20.5523 7.66667 21 7.66667 21 7.66667L23 10.6667ZM2 13.6667C0.343146 13.6667 -1 12.3235 -1 10.6667V0C-1 -1.65685 0.343146 -3 2 -3V3C1.44772 3 1 3 1 3V7.66667C1 7.66667 1.44772 7.66667 2 7.66667V13.6667ZM20 -3C21.6569 -3 23 -1.65685 23 0V10.6667C23 12.3235 21.6569 13.6667 20 13.6667V7.66667C20.5523 7.66667 21 7.66667 21 7.66667V3C21 3 20.5523 3 20 3V-3Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-7-inside-4_41_9)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_41_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V10.6667H0V0Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V10.6667H0V0Z",
    fill: "#F5F5F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1L-1 0H0ZM22 0H23L22 -1V0ZM22 10.6667V11.1667L23 10.6667H22ZM0 10.6667H-1L0 11.1667V10.6667ZM0 0V1H22V0V-1H0V0ZM22 0H21V10.6667H22H23V0H22ZM22 10.6667V10.1667H0V10.6667V11.1667H22V10.6667ZM0 10.6667H1V0H0H-1V10.6667H0Z",
    fill: "black",
    mask: "url(#path-9-inside-5_41_9)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1L-1 0H0ZM22 0H23L22 -1V0ZM22 10.6667V11.1667L23 10.6667H22ZM0 10.6667H-1L0 11.1667V10.6667ZM0 0V1H22V0V-1H0V0ZM22 0H21V10.6667H22H23V0H22ZM22 10.6667V10.1667H0V10.6667V11.1667H22V10.6667ZM0 10.6667H1V0H0H-1V10.6667H0Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-9-inside-5_41_9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeS);
export default __webpack_public_path__ + "static/media/Gauge_S.ef125c50c4a3b6a03391cf55f1db93d6.svg";
export { ForwardRef as ReactComponent };